import { RemoteCreateSemester } from 'data/usecases';
import { makeApiUrlEntitiesSemesters } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateSemester = (): RemoteCreateSemester => {
  return new RemoteCreateSemester(
    makeApiUrlEntitiesSemesters(),
    makeAxiosHttpClient(),
  );
};
